<template>
  <div class="search-view vh-100">
    <div id="myleftSidenav" class="myleftSidenav">
      <button class="close-btn" @click="Closemenu()">
        <i class="bi bi-x"></i>
      </button>
      <!-- <h3>Swan View / Floors </h3> -->
      <div class="stackerBox d-flex justify-content-center flex-column">

        <img id="BuildingImg" class="BuildingImg first StackerLeftImage" :src="BlockImg" />

        <div v-if="SelectedBlock == '1'" class="block1">
          <a class="floor blockfloor-1-1"  title="Block A1 - Floor 1" @click="OpenPlot(1)"></a>
          <a class="floor blockfloor-1-1-right" title="Block A1 - Floor 1" @click="OpenPlot(1)"></a>

          <a class="floor blockfloor-1-2" title="Block A1 - Floor 2" @click="OpenPlot(2)"></a>
          <a class="floor blockfloor-1-2-right" title="Block A1 - Floor 2" @click="OpenPlot(2)"></a>

          <a class="floor blockfloor-1-3" title="Block A1 - Floor 3" @click="OpenPlot(3)"></a>
          <a class="floor blockfloor-1-3-right" title="Block A1 - Floor 3" @click="OpenPlot(3)"></a>

          <a class="floor blockfloor-1-4" title="Block A1 - Floor 4" @click="OpenPlot(4)"></a>
          <a class="floor blockfloor-1-4-right" title="Block A1 - Floor 4" @click="OpenPlot(4)"></a>

          <a class="floor blockfloor-1-5" title="Block A1 - Floor 5" @click="OpenPlot(5)"></a>
          <a class="floor blockfloor-1-5-right" title="Block A1 - Floor 5" @click="OpenPlot(5)"></a>

          <a class="floor blockfloor-1-6" title="Block A1 - Floor 6" @click="OpenPlot(6)"></a>
          <a class="floor blockfloor-1-6-right" title="Block A1 - Floor 6" @click="OpenPlot(6)"></a>

          <a class="floor blockfloor-1-7" title="Block A1 - Floor 7" @click="OpenPlot(7)"></a>
          <a class="floor blockfloor-1-7-right" title="Block A1 - Floor 7" @click="OpenPlot(7)"></a>

          <a class="floor blockfloor-1-8" title="Block A1 - Floor 8" @click="OpenPlot(8)"></a>
          <a class="floor blockfloor-1-8-right" title="Block A1 - Floor 8" @click="OpenPlot(8)"></a>
        </div>
        <div v-if="SelectedBlock == '2'">
          <a class="floor blockfloor-2-1" title="Block A2 - Floor 1" @click="OpenPlot(1)"></a>
          <a class="floor blockfloor-2-1-right" title="Block A2 - Floor 1" @click="OpenPlot(1)"></a>

          <a class="floor blockfloor-2-2" title="Block A2 - Floor 2" @click="OpenPlot(2)"></a>
          <a class="floor blockfloor-2-2-right" title="Block A2 - Floor 2" @click="OpenPlot(2)"></a>

          <a class="floor blockfloor-2-3" title="Block A2 - Floor 3" @click="OpenPlot(3)"></a>
          <a class="floor blockfloor-2-3-right" title="Block A2 - Floor 3" @click="OpenPlot(3)"></a>

          <a class="floor blockfloor-2-4" title="Floor 4" @click="OpenPlot(4)"></a>
          <a class="floor blockfloor-2-4-right" title="Floor 4" @click="OpenPlot(4)"></a>

          <a class="floor blockfloor-2-5" title="Block A2 - Floor 5" @click="OpenPlot(5)"></a>
          <a class="floor blockfloor-2-5-right" title="Block A2 - Floor 5" @click="OpenPlot(5)"></a>

          <a class="floor blockfloor-2-6" title="Block A2 - Floor 6" @click="OpenPlot(6)"></a>
          <a class="floor blockfloor-2-6-right" title="Block A2 - Floor 6" @click="OpenPlot(6)"></a>

          <a class="floor blockfloor-2-7" title="Block A2 - Floor 7" @click="OpenPlot(7)"></a>
          <a class="floor blockfloor-2-7-right" title="Block A2 - Floor 7" @click="OpenPlot(7)"></a>

          <a class="floor blockfloor-2-8" title="Block A2 - Floor 8" @click="OpenPlot(8)"></a>
          <a class="floor blockfloor-2-8-right" title="Block A2 - Floor 8" @click="OpenPlot(8)"></a>

          <a class="floor blockfloor-2-9" title="Block A2 - Floor 9" @click="OpenPlot(9)"></a>
          <a class="floor blockfloor-2-9-right" title="Block A2 - Floor 9" @click="OpenPlot(9)"></a>

        </div>

        <div class="floors">
            <button class="chev-u mb-3 arrows-button " @click="down()"  @mousedown="startdown" @mouseleave="stopdown" @mouseup="stopdown" @touchstart="startdown" @touchend="stopdown" @touchcancel="stopdown">
                  <img clas="" src="../assets/img/chev-up.png" /> 
            </button>
            <div class="floor-number" @click="openMainModal(selected)">
                Floor {{ selected == 0 ? "G" : selected  }} 
            </div>
            <button class="chev-d mt-3 arrows-button" @click="up()" @mousedown="startup" @mouseleave="stopup" @mouseup="stopup" @touchstart="startup" @touchend="stopup" @touchcancel="stopup" >
                  <img src="../assets/img/chev-down.png" /> 
            </button>
        </div>

        <!-- <div
          v-for="(i, index) in FloorImages"
          :key="index"
          class="d-flex justify-content-between align-items-center Floor mb-3" :class="i.floor_level" >
          <div >{{ (i.floor_level == 'Basement') ? 'Garden Apartments' : i.floor_level }}</div>
          <div><span></span></div>
          <div @click="openMainModal(i.id)">
            <img :src="i.floor_image" />
          </div>
        </div> -->
      </div>
    </div>

     <div class="row g-0 h-100 BuildingWrapper" >

      <div class="building-container">
        <img id="BuildingImg" class="BuildingImg first" :src="BuildingImg" :style="{'opacity': isMenuOpen ? '25%' : '100%'}" @click="CloseMenuOnBlue()"/>
        

      
      </div>

      <div @mouseover="UpdateStackerImage(1)" @mouseleave="UpdateStackerImage()" @click="toggleSideBar('apt1'); showMenu = !showMenu;" class="apt apt1">  
      </div>
      <div @mouseover="UpdateStackerImage(2)" @mouseleave="UpdateStackerImage()" @click="toggleSideBar('apt2'); showMenu = !showMenu;" class="apt apt2">  </div>
    </div>

    <VueFinalModal
      v-model="showMainModal"
      :drag="true"
      :esc-to-close="true"
      :hide-overlay="true"
      :prevent-click="true"
      :fit-parent="false"
      :click-to-close="false"
      :lock-scroll="false"
      :content-style="{ width: '100%' }"
      :z-index-auto="true"
      :z-index="true"
      :z-index-base="1000"
      :style="{ top: '15%', width: '40%', left: '42%', zIndex: '3' }"
      :class="'openedParent'"
      >
      <div style="width: 100%" v-if="showMainModal">
        <PlotDetails :id="PlotId" :block="SelectedBlock"
          @bringForward="onForward()"
          @CloseModal="showMainModal = false"
          @showInnerModal="ShowImodal" />
      </div>
    </VueFinalModal>

  </div>
</template>

<script>
import { $vfm, VueFinalModal, ModalsContainer } from "vue-final-modal";
import PlotDetails from '@/components/PlotDetails/PlotDetails.vue';
import { ModalService } from '@/services/spec.service';

export default {
  name: "SearchStackerView",
  components: {
    VueFinalModal,
    PlotDetails
  },
  created(){
    document.title = "Stacker Search - Heybourne Park";
    this.PageViewCount();
  },
  data() {
    return {
      showMainModal: false,
      showInnerModal: false,
      showMenu: false,
      BuildingImg: (this.Image_url+"apartment-assets/haoff.jpg?new"),
      FloorImages: [],
      PlotId: "",
      SelectedBlock: "",
      InnerPlotId: null,
      BuildingLabel: "",
      BlockImg: "",
      intervalup:false,
      intervaldown:false,
      count:0,
      selected: 1,
      data1: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      data2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isMenuOpen: false
    };
  },
  methods: {

    OpenPlot(floor){
      this.selected = floor;
      this.PlotId = floor;
      this.showMainModal = true;

      if(this.SelectedBlock == '1'){
        this.BlockImg = this.Image_url+"apartment-assets/block-1/"+this.selected+".jpg?nocachess";
      }else{
        this.BlockImg = this.Image_url+"apartment-assets/block-2/"+this.selected+".jpg?nocachess";
      }

    },

    UpdateStackerImage(block){
      if(block == 1){
        this.BuildingImg = this.Image_url+"apartment-assets/ha1on.jpg?new";
      }else if(block == 2){
        this.BuildingImg = this.Image_url+"apartment-assets/ha2on.jpg?new";
      }else{

        if(this.SelectedBlock == ''){
          this.BuildingImg = this.Image_url+"apartment-assets/haoff.jpg?new";
        }
      }
    },
    startdown(){
          if(!this.intervaldown){
              this.intervaldown = setInterval(() => this.down(), 300)	
          }
      }, 
      stopdown(){
          clearInterval(this.intervaldown)
          this.intervaldown = false
      },
      startup(){
          if(!this.intervalup){
              this.intervalup = setInterval(() => this.up(), 300)	
          }
      }, 
      stopup(){
          clearInterval(this.intervalup)
          this.intervalup = false
      },
      up() {
          if (this.selected != 0) {
            
              if(this.selected != 1){
                  this.selected = this.selected - 1;
                  this.$emit('showDetail',  this.selected)
                  console.log('down')
                  this.OpenPlot(this.selected)
              }
          }

          if(this.SelectedBlock == '1'){
            this.BlockImg = this.Image_url+"apartment-assets/block-1/"+this.selected+".jpg?nocachess";
          }else{
            this.BlockImg = this.Image_url+"apartment-assets/block-2/"+this.selected+".jpg?nocachess";
          }
      },
      down() {

          if(this.SelectedBlock == '1'){
            if ((this.selected + 1) != this.data1.length) {
              this.selected = this.selected + 1;
              this.$emit('showDetail',  this.selected)
              this.OpenPlot(this.selected)
            }
          }else{
            if ((this.selected + 1) != this.data2.length) {
              this.selected = this.selected + 1;
              this.$emit('showDetail',  this.selected)
              this.OpenPlot(this.selected)
            }
          }

          if(this.SelectedBlock == '1'){
            this.BlockImg = this.Image_url+"apartment-assets/block-1/"+this.selected+".jpg?nocachess";
          }else{
            this.BlockImg = this.Image_url+"apartment-assets/block-2/"+this.selected+".jpg?nocachess";
          }
      },

    openMainModal(index) {
      this.PlotId = index
      this.showMainModal = true;
        if(screen.width <= 786){
          if (document.getElementById("myleftSidenav").offsetWidth == 0) {
            document.getElementById("myleftSidenav").style.width = "40%";
          } else {
            document.getElementById("myleftSidenav").style.width = "0px";
          }
        }

        

    },
    toggleSideBar(apt) {
      if (apt == "apt1") {
        this.BuildingImg = this.Image_url+"apartment-assets/ha1on.jpg?new";
        this.BuildingLabel = 'Block A1';
        this.SelectedBlock = '1'
        this.selected = 1;
        this.BlockImg = this.Image_url+"apartment-assets/block-1/"+this.selected+".jpg?nocachess";
        this.OpenPlot(this.selected)
        //  fetch(this.base_url+'GetBlockFloors&block=B')
        //     .then(response => response.json())
        //     .then(res => { 
        //         this.FloorImages = res.data
        //     });

      } else if (apt == "apt2") {
        this.BuildingImg = this.Image_url+"apartment-assets/ha2on.jpg?new";
        this.BuildingLabel = 'Block A2'
        this.SelectedBlock = '2'
        this.selected = 1;
        this.BlockImg = this.Image_url+"apartment-assets/block-2/"+this.selected+".jpg?nocachess";
        this.OpenPlot(this.selected)
        // fetch(this.base_url+'GetBlockFloors&block=A')
        //     .then(response => response.json())
        //     .then(res => { 
        //         this.FloorImages = res.data
        //     });

      }

      document.getElementById("BuildingImg").classList.remove("first");
        if (document.getElementById('myleftSidenav').offsetWidth == 0) {
          if (window.innerWidth >= 1120) {
              document.getElementById('myleftSidenav').style.width = "40%";
          } else {
              document.getElementById('myleftSidenav').style.width = "350px";
          }
          this.isMenuOpen = true;
        } 
    },
    ShowImodal(i){
      this.InnerPlotId = i
      this.showInnerModal = true
    },
    Closemenu(){
      if (document.getElementById("myleftSidenav").offsetWidth == 0) {
        document.getElementById("myleftSidenav").style.width = "40%";
      } else {
        document.getElementById("myleftSidenav").style.width = "0px";
      }
      this.isMenuOpen = false;
      this.selected = 1;
      this.BuildingImg = (this.Image_url+"apartment-assets/haoff.jpg?new");
    },

    CloseMenuOnBlue(){
      if(this.isMenuOpen){
        document.getElementById("myleftSidenav").style.width = "0px";
        this.isMenuOpen = false;
        this.BuildingImg = (this.Image_url+"apartment-assets/haoff.jpg?new");
        this.selected = 1;
      }
    },
    
    onForward(){
      let list = [];
      list = document.getElementsByClassName('openedParent');
      for (let item of list) {
        item.style.zIndex = 1000006;
      }
      ModalService.publishModalForward('true');      
    },
    PageViewCount(){
     if(sessionStorage.getItem('session_id') != null){
           let data = { 
               session_id: sessionStorage.getItem('session_id'),
               page_name: "Search Stacker"
           }
           fetch(this.base_url+'AddPageView',{
               method: 'POST', // or 'PUT'
               headers: {
                   
               },
               body: JSON.stringify(data),
               })
           .then(response => response.json())
           .then(res => {
              
           });
     }
    }
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "rustica-regular" !important;
}

body {
  pointer-events: none;
  overflow: hidden;
}

.BuildingWrapper{
  overflow: hidden;
}

.bi-x::before {
  background: #381b31;
  border-radius: 4px;
}


.myleftSidenav {
  height: calc(100vh - 70px);
  width: 0%;
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0;
  bottom: 0;
  background: #381b31;
  overflow-x: hidden;
  transition: 0.5s;
  margin-top: 0;
  margin-bottom: 70px;
  h3 {
    color: white;
    letter-spacing: 1.5px;
    font-weight: 500 !important;
    text-transform: uppercase;
    font-family: "rustica-light" !important;
    padding: 50px;
    font-size:1.50rem;
  }
}

.building-container{
  width:fit-content;
  background:#64a7a6;
}

.floors {
  position: absolute;
  right: 5%;
  text-align:center;
  background: rgba(255, 255, 255, 0.5);
  padding: 10px 0;
  border-radius: 10px;
  z-index:3;
}

.floor-number {
height: 40px;
background: #381b31;
color: #fff;
width: 100%;
text-align: center;
vertical-align: middle;
line-height: 43px;
position: relative;
cursor: pointer;

&::before {
  content: "";
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 20px solid #381b31;
  position: absolute;
  left: -10px;
  top: 5px;
}
}

.arrows-button {
background: transparent;
border: none;
img {
  pointer-events: none; 
}
}


.myleftSidenav a {
  //padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 20px;
  color: #fff;
  display: block;
  transition: 0.3s;
  text-transform: uppercase;
}

.myleftSidenav a:hover {
  color: #f1f1f1;
}

.stackerBox {
  width: 100%;
  height: 100%;
  overflow:hidden;
}

.Floor {
  color: #fff;
  img {
    width: 100%;
    height: inherit;
  }
  span {
    border: 1px solid white;
    width: 55px;
    display: inline-block;
    vertical-align: middle;
    position: static;
  }
}

.search-view {
  background-color: #381b31;

  .BuildingWrapper{
    justify-content:center;    
  }
  .BuildingImg {
    height: calc(100vh - 70px);
    width:auto;
  }
}

.BuildingImg {
  position: relative;
}

.apt {
  //background: red;
  position: absolute;
}

.apt.apt1 {
  width: 23%;
  height: 75%;
  top: 15%;
  left: 22%;
  opacity: 0.5;
  transform: rotate(-29deg);
  cursor: pointer;
}

.apt.apt2 {
  width: 22%;
  height: 70%;
  top: -11%;
  left: 45%;
  opacity: 0.5;
  transform: rotate(-48deg);
  cursor: pointer;
}

.close-btn {
    border: none;
    position: absolute;
    top: 10px;
    right: 15px;
    background: transparent;
    z-index:999;
    i{
        color: #cad636;
        font-size: 35px;
    }
  }

  .Basement div:nth-child(1) {
    width:100px
  }

  .Basement div:nth-child(2) span {
    width:35px
  }

  .floor {
    position: absolute;
    z-index: 2;
    opacity: .5;
    cursor: pointer;
  }

  .blockfloor-1-1 {
    padding: 0;
    left: -3%;
    top: 86.5%;
    width: 49.5%;
    height: 8.5%;
    background: transparent;
    transform: rotate(-2deg) perspective(200px) rotateY(-25deg);
  }

  .blockfloor-1-1-right {
    padding: 0px;
    left: 66.5%;
    top: 84.5%;
    width: 37.5%;
    height: 11%;
    background: transparent;
    transform: rotate(-1deg) perspective(200px) rotateY(25deg);
  }

.blockfloor-1-1 {
  padding: 0;
  left: -3%;
  top: 75.5%;
  width: 49.5%;
  height: 6.9%;
  background: transparent;
  transform: rotate(-7deg) perspective(200px) rotateY(-25deg);
}

.blockfloor-1-1-right {
  padding: 0px;
  left: 64.5%;
  top: 74.5%;
  width: 37.5%;
  height: 8.4%;
  background: transparent;
  transform: rotate(9deg) perspective(200px) rotateY(25deg);
}

  .blockfloor-1-2 {
    padding: 0;
    left: -3%;
    top: 69.5%;
    width: 51.5%;
    height: 6.0%;
    background: transparent;
    transform: rotate(-15deg) perspective(200px) rotateY(-25deg);
  }

  .blockfloor-1-2-right {
    padding: 0px;
    left: 64.5%;
    top: 64.5%;
    width: 37.5%;
    height: 7.0%;
    background: transparent;
    transform: rotate(9deg) perspective(200px) rotateY(25deg);
  }

  .blockfloor-1-3 {
    padding: 0;
    left: -3%;
    top: 63.5%;
    width: 54.5%;
    height: 6%;
    background: transparent;
    transform: rotate(-23deg) perspective(200px) rotateY(-25deg);
  }
  .blockfloor-1-3-right {
    padding: 0px;
    left: 64.5%;
    top: 53.5%;
    width: 37.5%;
    height: 7%;
    background: transparent;
    transform: rotate(9deg) perspective(200px) rotateY(25deg);
  }
  .blockfloor-1-4 {
    padding: 0;
    left: -12%;
    top: 59.5%;
    width: 59.5%;
    height: 5%;
    background: transparent;
    transform: rotate(-28deg) perspective(200px) rotateY(-25deg);
  }

  .blockfloor-1-4-right {
    padding: 0px;
    left: 64.5%;
    top: 43.5%;
    width: 37.5%;
    height: 7%;
    background: transparent;
    transform: rotate(9deg) perspective(200px) rotateY(25deg);
  }

  .blockfloor-1-5 {
    padding: 0;
    left: -12%;
    top: 52%;
    width: 59.5%;
    height: 4.8%;
    background: transparent;
    transform: rotate(-32deg) perspective(200px) rotateY(-25deg);
  }

  .blockfloor-1-5-right {
    padding: 0px;
    left: 64.5%;
    top: 38.5%;
    width: 37.5%;
    height: 7%;
    background: transparent;
    transform: rotate(30deg) perspective(160px) rotateY(25deg);
  }
  .blockfloor-1-6 {
    padding: 0;
    left: -12%;
    top: 49%;
    width: 61.5%;
    height: 4.0%;
    background: transparent;
    transform: rotate(-40deg) perspective(200px) rotateY(-25deg);
  }
  .blockfloor-1-6-right {
    padding: 0px;
    left: 64.5%;
    top: 28.5%;
    width: 37.5%;
    height: 7%;
    background: transparent;
    transform: rotate(30deg) perspective(160px) rotateY(25deg);
  }
  .blockfloor-1-7 {
    padding: 0;
    left: -12%;
    top: 41%;
    width: 61.5%;
    height: 4%;
    background: transparent;
    transform: rotate(-45deg) perspective(180px) rotateY(-25deg);
  }
  .blockfloor-1-7-right {
    padding: 0px;
    left: 64.5%;
    top: 18.5%;
    width: 37.5%;
    height: 7%;
    background: transparent;
    transform: rotate(30deg) perspective(160px) rotateY(25deg);
  }

  .blockfloor-1-8 {
    padding: 0;
    left: -15%;
    top: 35%;
    width: 61.5%;
    height: 4%;
    background: transparent;
    transform: rotate(-49deg) perspective(180px) rotateY(-25deg);
  }

  .blockfloor-1-8-right {
    padding: 0px;
    left: 65.5%;
    top: 20.5%;
    width: 47.5%;
    height: 7%;
    background: transparent;
    transform: rotate(52deg) perspective(160px) rotateY(25deg);
  }

  .blockfloor-2-1 {
    padding: 0px !important;
    left: 15%;
    top: 81.5%;
    width: 44.5%;
    height: 5%;
    background: transparent;
    transform: rotate(33deg) perspective(0px) rotateY(0deg);
  }
  .blockfloor-2-1-right{
    padding: 0px !important;
    left: 47%;
    top: 86%;
    width: 21.5%;
    height: 5%;
    background: transparent;
    transform: rotate(-48deg);
  }
  .blockfloor-2-2 {
    padding: 0px !important;
    left: 15%;
    top: 75.0%;
    width: 44.5%;
    height: 5%;
    background: transparent;
    transform: rotate(33deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-2-right{
    padding: 0px !important;
    left: 47%;
    top: 79%;
    width: 21.5%;
    height: 5%;
    background: transparent;
    transform: rotate(-48deg);
  }

  .blockfloor-2-3 {
    padding: 0px !important;
    left: 15%;
    top: 68.5%;
    width: 44.5%;
    height: 5%;
    background: transparent;
    transform: rotate(33deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-3-right{
    padding: 0px !important;
    left: 47%;
    top: 73%;
    width: 21.5%;
    height: 5%;
    background: transparent;
    transform: rotate(-48deg);
  }

  .blockfloor-2-4 {
    padding: 0px !important;
    left: 11%;
    top: 59.5%;
    width: 44.5%;
    height: 5%;
    background: transparent;
    transform: rotate(29deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-4-right {
    padding: 0px !important;
    left: 47%;
    top: 64%;
    width: 21.5%;
    height: 7%;
    background: transparent;
    transform: rotate(-25deg);
  }

  .blockfloor-2-5 {
    padding: 0px !important;
    left: 11%;
    top: 52%;
    width: 44.5%;
    height: 7%;
    background: transparent;
    transform: rotate(25deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-5-right {
    padding: 0px !important;
    left: 43%;
    top: 56%;
    width: 24.5%;
    height: 8%;
    background: transparent;
    transform: rotate(-25deg);
  }

  .blockfloor-2-6 {
    padding: 0px !important;
    left: 11%;
    top: 42.5%;
    width: 44.5%;
    height: 7%;
    background: transparent;
    transform: rotate(24deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-6-right {
    padding: 0px !important;
    left: 43%;
    top: 46%;
    width: 24.5%;
    height: 8%;
    background: transparent;
    transform: rotate(-25deg);
  }

  .blockfloor-2-7 {
    padding: 0px !important;
    left: 7%;
    top: 31.0%;
    width: 44.5%;
    height: 8%;
    background: transparent;
    transform: rotate(22deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-7-right {
    padding: 0px !important;
    left: 43%;
    top: 34%;
    width: 24.5%;
    height: 10%;
    background: transparent;
    transform: rotate(-25deg);
  }

  .blockfloor-2-8 {
    padding: 0px !important;
    left: 7%;
    top: 21%;
    width: 44.5%;
    height: 10%;
    background: transparent;
    transform: rotate(18deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-8-right {
    padding: 0px !important;
    left: 43%;
    top: 24%;
    width: 24.5%;
    height: 10%;
    background: transparent;
    transform: rotate(-25deg);
  }
  .blockfloor-2-9 {
    padding: 0px !important;
    left: 3%;
    top: 9%;
    width: 44.5%;
    height: 10%;
    background: transparent;
    transform: rotate(16deg) perspective(0px) rotateY(0deg);
  }

  .blockfloor-2-9-right {
    padding: 0px !important;
    left: 43%;
    top: 9%;
    width: 24.5%;
    height: 10%;
    background: transparent;
    transform: rotate(-25deg);
  }

  @media screen and (min-width: 1366px) {
      .ps-lg-6 {
        padding-left:6rem
      }
  }

@media screen and (max-width: 767px) {
    .vfm--fixed {
        width: 100% !important;
        left: 0 !important;
        top: 70px !important;
        z-index: 2014;
        height: 70%;
    }

    .Floor div:nth-child(1) {
        width: 100px;
    }

    .stackernav {
        top: 70px;
    }

    .search-view {
      margin-top:70px !important;
      height: calc(100vh - 140px) !important;
    }

    .myleftSidenav {
      margin-top:70px !important;
      height: calc(100vh - 140px) !important;
    }

    .building-container{
      height: fit-content!important;
    } 
    .search-view .BuildingImg{
      width: 100%;
      object-fit: cover;
      object-position: 41% 0px;
      height: unset;
    }

    .apt.apt1 {
      width: 25%;
      height: 21%;
      top: 15%;
      left: 20%;
  }
  .apt.apt2{
    width: 25%;
    height: 25%;
    top: 6%;
    left: 47%;
  }

  .StackerLeftImage{
    width: 100% !important;
    object-fit: cover;
    object-position: 41% 0px;
    height: 100% !important;
  }

  .arrows-button img {
    width:55px;
  }

}

@media screen and (max-width: 1024px) {
    .search-view {
      margin-top:70px !important
    }
}

</style>
